import React from "react";
import { STATS } from "@/mock";

const StatsBar = () => {
  return (
    <section
      data-testid="stats-bar"
      className="bg-brand-ink text-white border-y border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {STATS.map((s, i) => (
          <div
            key={s.label}
            data-testid={`stat-${i}`}
            className={`flex flex-col gap-2 ${
              i > 0 ? "lg:border-l lg:border-white/10 lg:pl-8" : ""
            }`}
          >
            <div className="font-heading text-4xl lg:text-5xl font-black tracking-tighter text-brand-cta">
              {s.value}
            </div>
            <div className="text-xs font-medium uppercase tracking-[0.2em] text-white/60">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsBar;
